import React from "react";
import TransportPriceDetail from "./TransportPriceDetail";

export default function TransportPrice({ contract, contractPriceDetails }) {
  return contractPriceDetails.map(cpd => <TransportPriceDetail contract={contract} cpd={cpd} key={cpd.id} />);
}
